import { API_URL } from './config';

// Strat unic pentru toate apelurile HTTP catre backend.
// Backend-ul raspunde la erori cu { success: false, message } (GlobalExceptionHandler).

export class ApiError extends Error {
    constructor(message, status, body) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.body = body;
    }
}

const getAuthHeader = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

async function request(path, { method = 'GET', body, auth = false, json = true } = {}) {
    const headers = { ...(auth ? getAuthHeader() : {}) };
    let payload = body;
    if (body && json && !(body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
        payload = JSON.stringify(body);
    }
    const response = await fetch(`${API_URL}${path}`, { method, headers, body: payload });
    const data = await response.json().catch(() => null);
    if (!response.ok) {
        const message = (data && data.message) || `Eroare server (${response.status})`;
        throw new ApiError(message, response.status, data);
    }
    return data;
}

export const apiGet = (path, opts) => request(path, { ...opts, method: 'GET' });
export const apiPost = (path, body, opts) => request(path, { ...opts, method: 'POST', body });
export const apiPut = (path, body, opts) => request(path, { ...opts, method: 'PUT', body });
export const apiDelete = (path, opts) => request(path, { ...opts, method: 'DELETE' });
